import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M338.789647,-0.0112941176 L338.789647,527.649882 L-0.0338823529,821.296941 L-0.0338823529,1919.98871 L1919.96612,1919.98871 L1919.96612,821.296941 L1581.25553,527.649882 L1581.25553,-0.0112941176 L338.789647,-0.0112941176 Z M451.730824,1203.94165 L451.730824,112.929882 L1468.20141,112.929882 L1468.20141,1203.94165 L1278.912,1355.28282 L641.020235,1355.28282 L451.730824,1203.94165 Z M1581.25553,677.071059 L1807.13788,872.798118 L1807.13788,932.882824 L1581.25553,1113.58871 L1581.25553,677.071059 Z M112.907294,932.882824 L112.907294,872.798118 L338.789647,677.071059 L338.789647,1113.58871 L112.907294,932.882824 Z M1807.13788,1077.56047 L1807.13788,1700.88282 L1569.05788,1399.32988 L1480.39906,1469.35341 L1747.05318,1807.04753 L172.879059,1807.04753 L439.646118,1469.35341 L350.987294,1399.32988 L112.907294,1700.88282 L112.907294,1077.56047 L601.377882,1468.33694 L1318.66729,1468.33694 L1807.13788,1077.56047 Z M1016.47059,282.352941 L1016.47059,564.705882 L1298.82353,564.705882 L1298.82353,677.647059 L1016.47059,677.647059 L1016.47059,960 L903.529412,960 L903.529412,677.647059 L621.176471,677.647059 L621.176471,564.705882 L903.529412,564.705882 L903.529412,282.352941 L1016.47059,282.352941 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconInvitationLine = /*#__PURE__*/function (_Component) {
  _inherits(IconInvitationLine, _Component);

  var _super = _createSuper(IconInvitationLine);

  function IconInvitationLine() {
    _classCallCheck(this, IconInvitationLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconInvitationLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconInvitation",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconInvitationLine.displayName = "IconInvitationLine";
  return IconInvitationLine;
}(Component);

IconInvitationLine.glyphName = 'invitation';
IconInvitationLine.variant = 'Line';
IconInvitationLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconInvitationLine;
export { IconInvitationLine };